import React, {Component, Fragment} from 'react';
import axios from 'axios';
import queryString from 'qs';
import RoomListItem from "../../components/RoomListItem/RoomListItem";


const API_URL = '/api/rooms/search';

class SearchForm extends Component {
    constructor(props) {
        super(props);
        document.title = 'Search free room';
    }

    state = {
        rooms: [],
        formData: {
            address: {
                value: "",
                isValid: true,
                message: null
            },
            numberOfBeds: {
                value: "",
                isValid: true,
                message: null
            },
            startDate: {
                value: "",
                isValid: true,
                message: null
            },
            endDate: {
                value: "",
                isValid: true,
                message: null
            }
        }
    };

    createQuery = () => {
        const address = !this.state.formData.address.value ? `address=` : `address=${this.state.formData.address.value}`;
        const numberOfBeds = !this.state.formData.numberOfBeds.value ? `numberOfBeds=` : `numberOfBeds=${this.state.formData.numberOfBeds.value}`;
        const startDate = !this.state.formData.startDate.value ? `startDate=` : `startDate=${this.state.formData.startDate.value}`;
        const endDate = !this.state.formData.endDate.value ? `endDate=` : `endDate=${this.state.formData.endDate.value}`;
        return [address, numberOfBeds, startDate, endDate].join('&');
    };
    formSubmit = (event) => {
        event.preventDefault();
        const query = this.createQuery();
        axios.get(`${API_URL}?${query}`)
            .then((response) => {
                this.setState({
                    rooms: response.data
                });
                this.props.history.push(`search?${query}`);
            })
    };

    componentDidMount() {
        const query = this.props.location.search;
        const values = queryString.parse(query);
        this.setState({
            formData: {
                address: {
                    value: values.address,
                    isValid: true,
                    message: null
                },
                numberOfBeds: {
                    value: values.numberOfBeds,
                    isValid: true,
                    message: null
                },
                startDate: {
                    value: values.startDate,
                    isValid: true,
                    message: null
                },
                endDate: {
                    value: values.endDate,
                    isValid: true,
                    message: null
                }
            }
        });

        if (query) {
            axios.get(`${API_URL}${query}`)
                .then((response) => {
                    this.setState({
                        rooms: response.data
                    });
                })
        }
    };

    inputChangeHandler = event => {
        const value = event.target.value;
        const fieldName = event.target.name;
        const updatedFormData = {...this.state.formData};
        updatedFormData[fieldName] = {
            value: value,
            isValid: true,
            message: null
        };
        this.setState({formData: updatedFormData})
    };

    render() {

        let today = new Date();
        let tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        const rooms = this.state.rooms.map(room => {
            return <RoomListItem
                key={room.id}
                hotelName={room.hotelName}
                hotelId={room.hotelId}
                id={room.id}
                name={room.name}
                imageUrl={room.imageUrl}
                numberOfBeds={room.numberOfBeds}
                pricePerNight={room.pricePerNight}
            />
        });

        const bgStyle = {
            height: "30vh",
            backgroundImage: "url('../assets/img/city-profile.jpg')",
            marginTop: "-20px",
            backgroundPosition: "top center"

        };

        return (


            <Fragment>
                <div className="page-header header-filter align-content-lg-center" data-parallax="true"
                     style={bgStyle}>
                    <div className="container">
                        <h1 className="card-title text-light">Search free rooms</h1>
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>


                <div className="main main-raised">
                    <div className="profile-content">
                        <div className="container">
                            <br/>
                            <form onSubmit={this.formSubmit}>
                                <div className="row">

                                    <div className="col form-group bmd-form-group">

                                        <label className="bmd-label-static" htmlFor="address">Address</label>
                                        <input
                                            className="form-control"
                                            type='text'
                                            name='address'
                                            onChange={this.inputChangeHandler}
                                            value={this.state.formData.address.value}
                                        />
                                    </div>
                                    <div className="col form-group bmd-form-group">
                                        <label className="bmd-label-static" htmlFor="numberOfBeds">Number of
                                            beds</label>
                                        <input
                                            className="form-control"
                                            type='text'
                                            name='numberOfBeds'
                                            onChange={this.inputChangeHandler}
                                            value={this.state.formData.numberOfBeds.value}
                                        />
                                    </div>
                                    <div className="col form-group bmd-form-group">
                                        <label className="bmd-label-static" htmlFor="address">Star date</label>
                                        <input
                                            className="form-control"
                                            type='date'
                                            name='startDate'
                                            onChange={this.inputChangeHandler}
                                            value={this.state.formData.startDate.value}
                                            min={today.toISOString().substring(0, 10)}

                                        />
                                    </div>
                                    <div className="col form-group bmd-form-group">
                                        <label className="bmd-label-static" htmlFor="address">End date</label>
                                        <input
                                            className="form-control"
                                            type='date'
                                            name='endDate'
                                            onChange={this.inputChangeHandler}
                                            value={this.state.formData.endDate.value}
                                            min={tomorrow.toISOString().substring(0, 10)}
                                        />
                                    </div>
                                    <div className="col form-group bmd-form-group">
                                        <button type="submit" className="btn btn-primary btn-sm">Search</button>
                                    </div>
                                </div>

                            </form>
                            <div className="container">
                                <div className="row">

                                    {rooms}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>


        );
    }
}

export default SearchForm







// WEBPACK FOOTER //
// ./src/containers/SearchForm/SearchForm.jsx